import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"

import "@/assets/css/reset.css"
import "@/assets/css/index.scss" // global css
import "./permission"

Vue.use(ElementUI)
Vue.config.productionTip = false

import WebSocketPlugin from "@/utils/WebSocketPlugin.js"
Vue.use(WebSocketPlugin, {
  url: process.env.VUE_APP_BASE_SOCKET
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app")
